<template>
  <div class="card">
    <div class="card-header">
      Schedule
    </div>
    <div class="p-6">
      <div class="text-gray-500">
        Only trigger this automation rule within these defined schedules:
      </div>
      <schedule-toggle 
        class="mt-6"
        :parent="form" 
        @toggle="methods.toggleSchedule" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScheduleCard',

  props: {
    form: {
      type: Object,
      required: true
    },
    
    methods: {
      type: Object,
      required: true
    }
  }
}
</script>